import { Network } from '../../../network/network-types';
import { QuickAuthAccount } from '../../../quick-auth/quick-auth-types';

export const ACCOUNT_SERIALIZATION_KEY = 'account-serialization-key';

export interface QuickAuthInitProps {
    network?: Network;
    account?: QuickAuthAccount;
}
